import Phaser, {
    Display,
    Loader
} from 'phaser'

import GuideAnimate from './GuideAnimate';

//*** VARIABLES ***/
let gameScale;
let padding = 40;
let bubbleX = 115;
let bubbleY = 385;
let thisBubbleX;
let thisBubbleY;
let guideX;
let guideY;

let speechContainer;
let guide;
let guideImg;
let bubbleImage;
let arm;
let currentEnglish;
let currentMaori;
let domText;
let textStyle;
let next;
let back;
let fontSize;
let utils;
let _this;

let guideAnimate;
let isProfile = false;

export default class Guide extends Phaser.Scene {
    constructor() {
        super('guide')
        _this = this;
    }

    preload() {
        gameScale = this.registry.values.scaleIt;
        // isEnglish = this.registry.values.isEnglish;
        padding = padding * gameScale;
        bubbleX = thisBubbleX = bubbleX * gameScale;
        bubbleY = thisBubbleY = bubbleY * gameScale;
        fontSize = 20 * gameScale;

        //9-slice scaling plugin for bubble graphic
        bubbleImage = this.textures.get('speech').getSourceImage();
        //this.bubble = this.add.image(-30 * gameScale, -50 * gameScale, 'speech');
        this.bubble = this.add.nineslice(
            -30 * gameScale, -50 * gameScale, // this is the starting x/y location
            bubbleImage.width, bubbleImage.height, // the width and height of your object
            'speech', // a key to an already loaded image
            [110 * gameScale, 70 * gameScale, 70 * gameScale, 67 * gameScale] // the width and height to offset for a corner slice
        )

    }
    create() {

        //this.input.setTopOnly(false);
        //        this.registry.events.on('changedata-isEnglish', this.handleLanguage, this);

        //Will need to check if it's already there etc for debugging and future skip intro cookies
        utils = this.scene.get('utils');
        // sounds = this.scene.get('sounds');
        next = utils.addImage(this, {
            id: 'nextEnglish',
            str: 'next'
        });

        arm = new Image();

        next.setVisible(false);

        back = utils.addImage(this, {
            id: 'backEnglish',
            str: 'back'
        });

        back.setVisible(false);

        //add opening image of guide 
        guideX = -55 * gameScale;
        guideY = 311 * gameScale;
        guide = this.add.container(guideX, guideY);
        guideImg = utils.addImage(this, {
            id: 'guide1'
        });
        this.children.bringToTop(this.bubble);
        guide.add(guideImg);
        //contain the bubble,text and buttons
        speechContainer = this.add.container(bubbleX, bubbleY);
        speechContainer.add(this.bubble);
        this.createText();

        guideAnimate = this.scene.add('guideAnimate', GuideAnimate, true, {
            speechContainer: speechContainer,
            guide: guide,
            guideImg: guideImg,
            arm: arm,
            domText: domText
        });



        this.scene.launch('intro');
        this.scene.pause('world');

        this.scene.bringToTop('menu');

        arm = utils.addImage(this, {
            id: 'guideArm',
            flip: true,
            x: 82,
            y: 310,
            rotation: 0,
            originX: 0,
            originY: 0
        });
        arm.visible = false;
        guide.add(arm);
        guide.bringToTop(guideImg);
    }

    createText() {
        domText = this.add.dom(0, 0).createFromHTML('');

        domText.setOrigin(0, 0);
        textStyle = domText.node.style;
        textStyle.fontSize = fontSize + 'px';

    }

    //So other scenes can retrieve the next button in the speechbubble
    getNext() {
        return (next);
    }
    //So other scenes can retrieve the next button in the speechbubble
    getBack() {
        return (back);
    }

    getSpeechContainer() {
        return (speechContainer);
    }
    //Other scenes can add unique listener to next button
    setNext(data) {
        if (data.callback) {
            next.off('pointerup');
            next.on('pointerup', data.callback, data.context);
        }
        next.setVisible(data.isVisible || true);
    }
    //Get the guide bubble to add interactivity
    getBubble() {
        this.input.setTopOnly(false);
        this.bubble.setInteractive();
        return (this.bubble);
    }
    //get the guide to add interactivity
    getGuide() {

        if (isProfile) {
            guide.setInteractive(new Phaser.Geom.Rectangle(guideImg.x, guideImg.y, guideImg.displayWidth, guideImg.displayHeight), Phaser.Geom.Rectangle.Contains);

        } else {
            guide.setInteractive(new Phaser.Geom.Rectangle(guideImg.x + 25 * gameScale, guideImg.y, guideImg.displayWidth / 2, guideImg.displayHeight), Phaser.Geom.Rectangle.Contains);

        }

        return (guide);
    }
    //Load alternative guide images in the background


    //Called often - each time a new speech bubble is needed
    speechBubble(data) {

        //Set the width
        let width = data.width || 350;
        textStyle.width = width * gameScale - padding * 2 + 'px';
        let align = data.align || 'center';
        textStyle.textAlign = align;
        let div = "<div class='speech'>"
        //Most will pass in the XML data but some are non-standard and will pass in the text
        let xmlLoader = data.xmlLoader;
        if (xmlLoader) {
            //Hold the English and Maori texts
            currentEnglish = xmlLoader.getEnglish();
            currentMaori = xmlLoader.getMaori();


            //Some speech bubbles are bilingual and show both languages
            if (xmlLoader.getAttribute('bilingual') == 'true') {
                domText.node.innerHTML = div + "<span class='speechExtra'>" + currentMaori + "</span><br /><br />" + currentEnglish + "</div>";
            } else {
                //Most show one language at a time
                domText.node.innerHTML = div + xmlLoader.getLanguage() + "</div>";
            }
        } else {
            domText.node.innerHTML = div + data.text + "</div>";
        }
        //check if we need to highlight any keywords
        let keyword = this.registry.values.keyword
        if (keyword) {
            if (keyword[0] == 'guide') domText.node.innerHTML = utils.highlightText(domText.node.innerHTML);
        }

        domText.updateSize();

        //check if this is a different speaker... if so, x,y, flip and arm can be affected
        this.bubble.setFlipX(data.flip || false);
        speechContainer.x = data.x * gameScale || thisBubbleX;
        speechContainer.y = data.y * gameScale || thisBubbleY;

        //Based on the new width and height position other elements
        this.placeText();

        //Any requests to add special gameObjects to speech bubble?
        this.clearSpecial();

        if (data.objs) {
            this.specialObjects(data);
        } else {
            this.setupButtons({
                data: data
            });
        }

        guideAnimate.animateBubbleIn({
            speaker: arguments[0].speaker || 'marama'
        });
    }

    clearSpecial() {

        let toRemove = speechContainer.getAll('name', 'special');

        for (let index = 0; index < toRemove.length; index++) {
            toRemove[index].visible = false;
            speechContainer.remove(toRemove[index]);
        }

    }
    specialObjects(settings) {
        let data = settings.objs
        let index = 0;
        let obj;
        let h;
        let oldObj;
        let oldH;
        let firstY;
        let biggestW = 0;
        let w;
        let isCenter = textStyle.textAlign;
        if (isCenter != 'center') {
            isCenter = false;
        } else {
            isCenter = true;
        }

        do {
            obj = data[index];
            speechContainer.add(obj);
            obj.visible = true;

            obj.x = domText.x + (domText.width / 2) - speechContainer.x;
            if (!isCenter) obj.x = domText.x - speechContainer.x;
            obj.name = 'special';
            //containers do not have a width and height by default and size set in originating file does not make it over
            h = obj.getData('height');

            w = obj.getData('width');
            obj.setSize(w, h);
            if (index == 0) {
                firstY = domText.y + domText.height - speechContainer.y + h / 2 + padding / 3;
                obj.y = firstY;
            } else {
                oldObj = data[index - 1];
                obj.y = oldObj.y + h / 2 + oldH / 2 + padding / 3;

            }
            if (w > biggestW) biggestW = w;

            oldH = h;
            index++;

        } while (index < data.length)

        /*let bubbleWidth = domText.width + padding * 2;
        
        if (biggestW > domText.width) {
            bubbleWidth = biggestW + padding * 2;
            textStyle.width = biggestW + 'px';
           
        }*/
        let differenceY = obj.y - firstY

        let bubbleHeight = domText.height + padding * 2 + oldH / 2 + differenceY + padding / 2;
        //If there is the next button add that to the height + padding
        if (!settings.isButtons) bubbleHeight += next.height + padding / 2;

        //setup buttons, even if it is to hide them
        this.setupButtons({
            data: settings,
            //width: bubbleWidth,
            height: bubbleHeight,
            y: obj.y + obj.height / 2 + next.height / 2 + padding / 3
        });

    }

    setupGuide() {
        // guide.disableInteractive();
        guide.removeAllListeners();
        //Hide the guide while we muck around
        //guide.visible = false;
        //Store the argments
        let data = arguments[0];
        let id = data.id || "guide1"

        //Make sure alternative texture is loaded, or else wait until it is
        /* if (!this.textures.exists(id)) {
             this.time.delayedCall(1000, this.setupGuide, [a], this);
             return;
         }*/
        //Resume the guide when it is being setup for a new scene
        if (this.scene.isPaused('guide')) this.scene.resume('guide');

        //Hide the arm by default
        arm.visible = false;

        //Change the texture as needed
        guideImg.setTexture(id);
        //change flip of bubble and guide
        guideImg.setFlipX(data.flip || false);
        this.bubble.setFlipX(data.flip || false);

        //Find the x and y based on arguments or which ID was given
        let thisX = data.x * gameScale || guideX;
        let thisY = data.y * gameScale || guideY;

        switch (data.id) {
            case 'guideProfile':
                isProfile = true;
                thisX = thisX + 40 * gameScale;
                thisY = thisY - 60 * gameScale;
                let armFlip = data.flip || false;
                armFlip = !armFlip;

                //guide.bringToTop(arm);

                arm.setFlipX(!(data.flip || false));
                guideAnimate.setupArm(arm);

                arm.visible = true;
                //thisBubbleX = bubbleX + 42 * gameScale;
                //thisBubbleY = bubbleY - 51 * gameScale;
                thisBubbleX = thisX + 180 * gameScale;
                thisBubbleY = thisY + 80 * gameScale;
                break;
            default:
                arm.visible = false;
                isProfile = false;
                thisY = thisY; // * gameScale;
                thisX = thisX; // * gameScale;
                thisBubbleX = thisX + 170 * gameScale; //bubbleX;
                thisBubbleY = thisY + 74 * gameScale; //bubbleY;
                break;
        }

        //adjust x,y based on image and flip
        guide.x = thisX;
        guide.y = thisY;

        speechContainer.x = thisBubbleX;
        speechContainer.y = thisBubbleY;
        //Is the guide walking in?
        if (data.walk) {
            guideAnimate.walkIn(data.callback)
        } else {
            guide.visible = true;
            this.scene.bringToTop('guide');
            this.scene.bringToTop('toolTips');
            this.scene.bringToTop('menu');
            if (data.callback) data.callback();
        }
    }

    setupButtons(data) {

        //hold the data that was passed to the guide
        let settings = data.data;
        //width of the bubble
        let width = data.width || domText.width + padding * 2;
        //height of the bubble
        let height = data.height || domText.height + padding * 2 + next.height;
        this.resizeBubble(width, height);
        //Start by hiding the buttons
        back.setVisible(false);
        next.setVisible(false);
        //this time the buttons are supplied special order so hide the default next/back
        if (settings.isButtons) return;

        let btnArray = [];

        //next x
        let nextX = data.x || domText.x + (domText.width / 2) - speechContainer.x;
        let nextY = data.y || domText.y + domText.height + 15 * gameScale + next.height / 2 - speechContainer.y;
        //remove any old up listeners
        //next.off('pointerup');
        //was a special function given, if not increment the xml speech
        let f = settings.callback || settings.xmlLoader.incSpeech;
        //context for the callback
        let c = settings.context || settings.xmlLoader;

        next.x = nextX;
        next.y = nextY;

        //Add to global buttons stuff, pass in functions for over
        //utils.globalButton(next);
        let isBack = settings.isBack || false;
        btnArray.push(next);
        if (isBack) {
            btnArray.push(back);

            let backX = data.x || ((domText.x + domText.width / 2) - back.width / 2 - padding / 8) - speechContainer.x;

            back.y = nextY - 12 * gameScale;
            back.x = backX;
            next.x = back.x + back.width + padding / 8;

        }

        for (let index = 0; index < btnArray.length; index++) {
            let btn = btnArray[index];
            btn.setVisible(true);
            btn.off('pointerup');
            speechContainer.add(btn);
            utils.globalButton(btn);
        }

        if (isBack) {
            back.on('pointerup', settings.xmlLoader.decSpeech, settings.xmlLoader);
            back.disableInteractive();
            back.alpha = 0.5;
        }
        next.on('pointerup', f, c);

        this.children.bringToTop(domText);
    }

    placeText() {

        if (this.bubble.flipX) {
            domText.x = speechContainer.x + this.bubble.x + padding / 1.25;
        } else {
            domText.x = speechContainer.x + this.bubble.x + padding * 1.25;
        }

        domText.y = speechContainer.y + this.bubble.y + padding;
    }
    resizeBubble(width, height = this.bubble.height) {

        if (width < 140 * gameScale) width = 140 * gameScale;
        if (height < 180 * gameScale) height = 180 * gameScale;
        this.bubble.resize(width, height);
        //this.bubble.displayWidth = width;
        //this.bubble.displayHeight = height;

    }



    removeBubble() {
        domText.node.innerHTML = "";
        speechContainer.setVisible(false);
    }

    animateBubbleOut() {
        guideAnimate.animateBubbleOut();

    }





}